import { render, staticRenderFns } from "./PillBadgeContextual.vue?vue&type=template&id=216b17a8&"
import script from "./PillBadgeContextual.vue?vue&type=script&lang=js&"
export * from "./PillBadgeContextual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports